export default {
  OK: "ตกลง",
  CLOSE: "บัญชีถูกปิด!",
  BLOCK: "บัญชีถูกบล็อก!",
  FREEZE: "บัญชีถูกอายัด",
  SUSPEND: "บัญชีของคุณเปลี่ยนเป็นดูได้เท่านั้น",
  passwordRequired: "ต้องการรหัสผ่าน!",
  usernameRequired: "ต้องมีชื่อผู้ใช้!",
  incompletedRequest: "เกิดข้อผิดพลาดบางอย่าง ...",
  session_not_exists: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ ...",
  session_expired: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ ...",
  sessionExpired: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ ...",
  invalidSession: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ ...",
  accountIdRequired: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ ...",
  NoUserAccessRight: "ปฏิเสธการอนุญาต! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  account_not_exists: "รหัสผ่านไม่ถูกต้อง.",
  invalid_password: "รหัสผ่านไม่ถูกต้อง.",
  secondary_account_exists: "ชื่อเล่นของคุณถูกสร้างไว้แล้ว",
  systemError: "ข้อผิดพลาดระบบภายใน",
  new_login_id_exists: "ชื่อเล่นไม่ถูกต้องโปรดลองตั้งชื่อเล่นอื่น",
  loginLimit: "คุณเข้าสู่ระบบบ่อยเกินไปโปรดลองอีกครั้งหลังจาก 1 นาที ...",
  requestLimit: "คุณมีคำขอบ่อยเกินไป",
  insufficient_balance: " เครดิตไม่เพียงพอ ",
  loginFailed: "การเข้าสู่ระบบล้มเหลวโปรดลองอีกครั้งในภายหลัง",
  requestFailed: "การเชื่อมต่อของคุณไม่เสถียร โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
  requestPending: "รอการร้องขอ ...",
  close: "บัญชีถูกปิด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  suspend: "บัญชีถูกระงับ! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  freeze: "บัญชีถูกอายัด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  alphaNumOnly: "ตัวอักษรและตัวเลขเท่านั้น",
  isRequired: "โปรดป้อน {fname}",
  isMinValue: "{fname} ต้องมีอย่างน้อย {value}",
  isMaxValue: "{fname} ต้องน้อยกว่าหรือเท่ากับ {value}",
  isMinLength: "{fname} ต้องมีอักขระอย่างน้อย {fvalue} ตัว ",
  isMaxLength: "{fname} ต้องน้อยกว่าหรือเท่ากับอักขระ {value}",
  isAlpha: "{fname} ยอมรับเฉพาะตัวอักษรเท่านั้น",
  isAlphaNum: "{fname} ยอมรับเฉพาะตัวอักษรและตัวเลข",
  isNumeric: "{fname} ยอมรับเฉพาะตัวเลข",
  isEmail: "{fname} ยอมรับที่อยู่อีเมลที่ถูกต้องเท่านั้น",
  isIpAddress: "{fname} ยอมรับเฉพาะที่อยู่ IPv4 ที่ถูกต้อง",
  isSameAs: "{fname} ต้องเหมือนกับ {fname 2}",
  isUrl: "{fname} ยอมรับ URL เท่านั้น",
  containAlphaNum: "{fname} ต้องมีตัวอักษรอย่างน้อยหนึ่งตัวและหนึ่งหมายเลข",
  selectOption: "กรุณาเลือก {fname}",
  notSameAs: "{fname} และ {fname 2} ต้องไม่เหมือนกัน",
  currPasswordRequired: "ต้องใช้รหัสผ่านปัจจุบัน!",
  newPasswordRequired: "ต้องการรหัสผ่านใหม่!",
  confirmNewPasswordRequired: "ยืนยันว่าต้องการรหัสผ่านใหม่!",
  passwordsNotMatch: "รหัสผ่านไม่ตรงกัน!",
  nickNameRequired: "ต้องมีชื่อเล่น!",
  startDateRequired: "ต้องระบุวันที่เริ่ม!",
  endDateRequired: "ต้องระบุวันที่สิ้นสุด!",
  pageSizeRequired: "ต้องระบุขนาดหน้าเพจ!",
  pageNumberRequired: "ต้องระบุหมายเลขหน้าเพจ!",
  sportsTypeRequired: "ต้องมีประเภทกีฬา!",
  workingDateRequired: "ต้องระบุวันทำงาน!",
  leagueIdRequired: "ต้องระบุลีก ID!",
  isOutrightRequired: "จำเป็นต้องขอข้อมูล",
  duplicate_debit_record: "อัตราเดิมพันกำลังอัปเดต ...",
  invalidOddsBall: "อัตราเดิมพันกำลังอัปเดต ..",
  oddsDisplayInvalid: "อัตราเดิมพันกำลังอัปเดต ...",
  oddsIsUpdating: "อัตราเดินพันกำลังอัปเดต ...",
  unableToGetBalanceAtTheMoment: "ข้อผิดพลาดเซิร์ฟเวอร์ภายใน",
  atLeastTwoMatchToBetParlay: "อย่างน้อยผสมการแข่งขันสองนัดเพื่อเดิมพันในพาร์เลย์",
  maxParlayTicket: "เข้าถึงตั๋วสูงสุดต่อพาร์เลย์!",
  matchHide: "แมตช์นี้ไม่พร้อมใช้งาน โปรดลองแมตช์อื่น",
  matchNotAllowBet: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  invalidBets: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  invalidBet: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  betOverMaxPerMatch: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  betOverMax: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  betLowerMin: "เงินเดิมพันของคุณน้อยกว่าเงินเดิมพันขั้นต่ำ",
  betOverMaxPayout: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  invalidBetType: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  memberInactive: "บัญชีไม่ทำงาน! โปรดติดต่อทีมอัพไลน์ของคุณเพื่อดำเนินการต่อ",
  memberCommissionNotSetup: "ไม่ได้ตั้งค่าคอมมิชชั่น",
  matchNotActive: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  invalidBetTeam: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  invalidOdds: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  betOverMaxBet: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  invalidCurrency: "สกุลเงินที่จะเดิมพันไม่ถูกต้อง",
  betOverLimit: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  selectLeague: "โปรดเลือกอย่างน้อย 1 ลีก",
  game_maintenance: "เกมกำลังปิดปรับปรุง",
  betTypeRequired: "ต้องระบุประเภทการเดิมพัน.",

  liveCasinoDisabled: "ปิดการใช้งานคาสิโนสด",
  lotteryDisabled: "ปิดการใช้งานลอตเตอรี่",
  MiniGameDisabled: "ปิดการใช้งานมินิเกม"
};
